import { render, staticRenderFns } from "./PremiumCommissionSelector.vue?vue&type=template&id=30fd28bf&scoped=true&"
import script from "./PremiumCommissionSelector.vue?vue&type=script&lang=ts&"
export * from "./PremiumCommissionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PremiumCommissionSelector.vue?vue&type=style&index=0&id=30fd28bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd28bf",
  null
  
)

export default component.exports